import Box from '@mui/material/Box';
import type { LoaderArgs } from '@remix-run/node';
import { json } from '@remix-run/node';
import { Outlet, useMatches } from '@remix-run/react';
import * as React from 'react';
import Cart, { cartWidth } from '~/components/Cart';
import Footer from '~/components/Footer';
import Navbar from '~/components/Navbar';
import type { Cart as TCart } from '~/services/api.server';
import { scApi } from '~/services/api.server';
import { getUpdatedAuthentication } from '~/services/auth.server';
import { getSession } from '~/services/session.server';

export async function loader({ request }: LoaderArgs) {
  const [{ user }, session] = await Promise.all([getUpdatedAuthentication(request), getSession(request)]);
  const accountId = session.get('accountId');

  if (user) {
    return json({ user: await scApi.getMe(user.accessToken, accountId) });
  }

  return json({ user: null });
}

export default function Fullbleed() {
  const { cart }: { cart: TCart } = useMatches()[0].data;
  const { designLabQueueQty }: { designLabQueueQty: number } = useMatches()[0].data;

  const [openCart, setOpenCart] = React.useState(false);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar transparent={true} openCart={openCart} setOpenCart={setOpenCart} designLabQueueQty={designLabQueueQty} />
      <Box sx={{ flex: '1 0 auto', width: openCart ? { md: `calc(100vw - ${cartWidth}px)`, xl: '100%' } : '100%' }}>
        <Outlet />
      </Box>
      <Box sx={{ flexShrink: 0 }}>
        <Footer />
      </Box>
      <Cart cart={cart} open={openCart} setOpenCart={setOpenCart} />
    </Box>
  );
}
